import { API } from '@shared/types/api';
export interface MBReaction {
  type: API.ReactionType;
  emoji: string;
}

export const reactionTypes: API.ReactionType[] = [
  'GRINNING',
  'THUMBS_UP',
  'THUMBS_DOWN',
  'HEART',
  'OKAY_HAND',
  'TADA',
  'CRYING_FACE',
];

export function getReactionEmoji(type: API.ReactionType): string {
  switch (type) {
    case 'GRINNING':
      return '😁';
    case 'THUMBS_UP':
      return '👍';
    case 'THUMBS_DOWN':
      return '👎';
    case 'HEART':
      return '❤️';
    case 'OKAY_HAND':
      return '👌';
    case 'TADA':
      return '🎉';
    case 'CRYING_FACE':
      return '😢';
  }
}

export const reactions: MBReaction[] = reactionTypes.map(type => {
  const emoji = getReactionEmoji(type);
  return { type, emoji };
});
